export const MapiqMapMessage = ({ children }: { children: string }) => {
  return (
    <div
      role="alert"
      className="flex size-full items-center justify-center p-6 text-center font-semibold">
      {children}
    </div>
  );
};
